// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1Fa1r","options":"AnswerScale_options__2skQq","selected":"AnswerScale_selected__1E5wz"};